// extracted by mini-css-extract-plugin
export default {"option":"TopicPermissionInfo-module__option--i9cEE","icon":"TopicPermissionInfo-module__icon--WoKsn","animatedBackground":"TopicPermissionInfo-module__animatedBackground--L2lVc"};